<template>
  <div class="rs-settings-card">
    <h5 v-if="title">
      {{ title }}
    </h5>
    <slot name="banner" />
    <RsCard>
      <slot />

      <template
        v-if="noFooter === false"
        #footer
      >
        <div class="p-3 row m-0 justify-content-end">
          <slot name="card-footer" />
          <RsButton
            class="btn-save"
            :disabled="disableBtn"
            @click="click"
          >
            Save
          </RsButton>
        </div>
      </template>
    </RsCard>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsSettingsCard',

  props: {
    title: String,
    noFooter: {
      type: Boolean,
      default: false,
    },
    disableBtn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasSlot() {
      const slots = Object.keys(this.$slots);
      return slots.includes('default');
    },
  },
  methods: {
    click() {
      this.$emit('clicked-save');
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.rs-settings-card{
  margin-bottom: 2rem;
  h5{
    margin-bottom: 1rem;
  }
  p{
    font-size: 0.875rem;
    margin-bottom: 0;
  }
  .rs-card{
    &__body{
      padding: 0;
    }
    &__footer{
      border-top: none;
      background-color: #EDEEF5;
      .btn-save{
        margin-left: auto;
      }
    }
  }
}
</style>
